import { render, staticRenderFns } from "./FreshdeskLauncher.vue?vue&type=template&id=567665ee&scoped=true&"
import script from "./FreshdeskLauncher.vue?vue&type=script&lang=ts&"
export * from "./FreshdeskLauncher.vue?vue&type=script&lang=ts&"
import style0 from "./FreshdeskLauncher.vue?vue&type=style&index=0&id=567665ee&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567665ee",
  null
  
)

export default component.exports